import { Link } from "react-router";
import { Logo } from "../branding/Logo";

const LICENSE_LINKS = [
  { label: "Clase B — Automóviles particulares", href: "/licencia-clase-b" },
  { label: "Clase C — Motocicletas", href: "/licencia-clase-c" },
  { label: "Clase CR — Triciclos de carga", href: "/licencia-clase-cr" },
  { label: "Clase A1 — Taxis", href: "/licencia-clase-a1" },
  { label: "Clase A2 — Buses y ambulancias", href: "/licencia-clase-a2" },
  { label: "Clase A3 — Buses sin límite de pasajeros", href: "/licencia-clase-a3" },
  { label: "Clase A4 — Camiones rígidos", href: "/licencia-clase-a4" },
  { label: "Clase A5 — Tractocamiones articulados", href: "/licencia-clase-a5" },
  { label: "Clase D — Maquinaria automotriz", href: "/licencia-clase-d" },
  { label: "Clase E — Tracción animal", href: "/licencia-clase-e" },
  { label: "Clase A1* / A2* — Licencias antiguas", href: "/licencia-clase-a1-a2" },
];

const OFFICIAL_LINKS = [
  { label: "CONASET — Mejores Conductores", href: "https://mejoresconductores.conaset.cl" },
  { label: "Licencia Digital CONASET", href: "https://licenciadigital.conaset.cl" },
  { label: "ChileAtiende — Licencia clase B", href: "https://www.chileatiende.gob.cl/fichas/24065-licencia-de-conducir-no-profesional-clase-b" },
  { label: "Registro Civil — Certificados", href: "https://www.registrocivil.cl/principal/servicios-en-linea" },
  { label: "Ley de Tránsito N° 18.290", href: "https://www.bcn.cl/leychile/navegar?idNorma=5518" },
  { label: "Cuestionario oficial A1*/A2*/D/E (PDF)", href: "https://mejoresconductores.conaset.cl/assets/data/pdf/A1A2/cuestionario_clase_A1_A2_D_E_actualizado_30-09-2024.pdf" },
];

const PLATFORM_LINKS = [
  { label: "Cómo funciona", href: "/como-funciona" },
  { label: "Planes", href: "/planes" },
  { label: "Obtener licencia", href: "/obtener-licencia" },
  { label: "Renovar licencia", href: "/renovar-licencia-de-conducir" },
  { label: "Sacar hora por comuna", href: "/licencia-de-conducir" },
  { label: "Escuelas de conductores", href: "/escuelas-de-conductores" },
  { label: "Normativa de tránsito", href: "/normativa" },
  { label: "Contacto", href: "/contacto" },
  { label: "Términos y condiciones", href: "/terminos" },
  { label: "Política de privacidad", href: "/politica-privacidad" },
];

const WHATSAPP_URL =
  "https://wa.me/56964378594?text=Hola%20Escuela%20Vial%2C%20quiero%20hacer%20una%20consulta.";

export function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-gray-100 bg-white">
      <div className="mx-auto max-w-6xl px-4 py-12">
        <div className="grid gap-10 sm:grid-cols-2 lg:grid-cols-4">

          {/* Marca */}
          <div className="flex flex-col gap-4">
            <a href="/" aria-label="Inicio Escuela Vial">
              <Logo className="h-6 w-auto opacity-80" />
            </a>
            <p className="text-sm text-gray-500 leading-relaxed">
              Practica el examen teórico de conducir con preguntas de fuentes oficiales
              basadas en el sistema CONASET de Chile.
            </p>
            <a
              href="https://www.instagram.com/escuela.vial/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-gray-400 transition-colors hover:text-gray-600"
            >
              <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <rect width="20" height="20" x="2" y="2" rx="5" ry="5"/>
                <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                <line x1="17.5" x2="17.51" y1="6.5" y2="6.5"/>
              </svg>
              @escuela.vial
            </a>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-gray-400 transition-colors hover:text-gray-600"
            >
              <svg
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M12.04 2a9.87 9.87 0 0 0-8.52 14.84L2.5 22l5.28-1a9.9 9.9 0 0 0 4.26.96h.01A9.98 9.98 0 0 0 22 12.02 9.96 9.96 0 0 0 12.04 2Zm5.83 14.12c-.24.68-1.38 1.29-1.93 1.34-.5.05-1.13.07-1.82-.12-.42-.13-.96-.31-1.65-.61-2.9-1.25-4.79-4.17-4.94-4.36-.14-.19-1.18-1.57-1.18-3s.75-2.13 1.02-2.42c.27-.29.59-.36.78-.36h.57c.18.01.43-.07.67.51.24.58.82 2 .89 2.14.07.15.12.32.02.51-.1.2-.15.32-.29.49-.14.17-.31.38-.44.51-.15.15-.3.31-.13.6.17.29.76 1.25 1.63 2.03 1.12 1 2.06 1.31 2.35 1.46.29.14.46.12.63-.07.17-.2.73-.85.92-1.14.19-.29.39-.24.66-.15.27.1 1.72.82 2.02.97.29.14.49.22.56.34.07.12.07.7-.17 1.33Z" />
              </svg>
              WhatsApp
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=cl.escuelavial"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-2 text-sm text-gray-400 transition-colors hover:text-gray-600"
            >
              <svg aria-hidden="true" width="15" height="15" viewBox="0 0 512 512" focusable="false">
                <path fill="#34A853" d="M35 22.6c8.5-4.2 18.8-4 27.6 1.1l275.1 156.7L288.6 256 35 22.6z" />
                <path fill="#4285F4" d="M35 22.6 288.6 256 35 489.4c-8.6-4.3-14.5-13.1-14.5-23.5V46.1c0-10.4 5.9-19.2 14.5-23.5z" />
                <path fill="#EA4335" d="M35 489.4 288.6 256l49.1 75.6L62.6 488.3c-8.8 5.1-19.1 5.3-27.6 1.1z" />
                <path fill="#FBBC04" d="M429.4 233.6c17 9.9 17 34.5 0 44.4l-91.7 53.2L288.6 256l49.1-75.6 91.7 53.2z" />
              </svg>
              Google Play
            </a>
            <p className="text-xs text-gray-400">
              © {year} Escuela Vial.<br />Todos los derechos reservados.
            </p>
          </div>

          {/* Tipos de licencia */}
          <div>
            <h3 className="mb-4 text-xs font-semibold uppercase tracking-wider text-gray-400">
              Tipos de licencia
            </h3>
            <ul className="space-y-2">
              {LICENSE_LINKS.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Recursos oficiales */}
          <div>
            <h3 className="mb-4 text-xs font-semibold uppercase tracking-wider text-gray-400">
              Recursos oficiales
            </h3>
            <ul className="space-y-2">
              {OFFICIAL_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="flex items-center gap-1.5 text-sm text-gray-500 hover:text-gray-900 transition-colors"
                  >
                    {l.label}
                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="shrink-0 opacity-40">
                      <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" />
                      <polyline points="15 3 21 3 21 9" />
                      <line x1="10" y1="14" x2="21" y2="3" />
                    </svg>
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* Plataforma */}
          <div>
            <h3 className="mb-4 text-xs font-semibold uppercase tracking-wider text-gray-400">
              Escuela Vial
            </h3>
            <ul className="space-y-2">
              {PLATFORM_LINKS.map((l) => (
                <li key={l.href}>
                  <Link
                    to={l.href}
                    className="text-sm text-gray-500 hover:text-gray-900 transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

        </div>

        <div className="mt-10 border-t border-gray-100 pt-6 text-center text-xs text-gray-400">
          Información basada en fuentes oficiales de{" "}
          <a
            href="https://mejoresconductores.conaset.cl"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-600"
          >
            CONASET
          </a>
          {" "}y{" "}
          <a
            href="https://www.chileatiende.gob.cl"
            target="_blank"
            rel="noopener noreferrer"
            className="underline hover:text-gray-600"
          >
            ChileAtiende
          </a>
          . Escuela Vial no es un organismo oficial del Estado.
        </div>
      </div>
    </footer>
  );
}
